import React, { useState, useEffect, useContext } from "react"

import { useFirebase } from "@meddbriefer/mdb-firebase"

import { AuthContext } from '@meddbriefer/mdb-auth'

import {logicalExprParser} from "../utils"

import { doVitalsCounts } from "@meddbriefer/analysis"
import { criticalInterventions as intvsCritical, vitalsToStep } from "@meddbriefer/feedback-data/analysisData"
import { intvStatusRules } from "@meddbriefer/feedback-data/analysisData"



export const ScenarioContext = React.createContext()

const scenarioTimer = (scenario) => {
    return {
        id: 'scenario',
        duration: scenario.info.maxTime * 60,
        action: {type: "timeExpired"},
        payload: "time expired",
        timeRemaining: scenario.info.maxTime * 60,
        expired: false
    }
}

const getInitialVitals = (scenario) => {
    // console("in getInitVitals")
    const initVitals = {}
    Object.entries(scenario.vitalSigns).forEach(([vitalSign, values]) => {
        // console.log(vitalSign, values)
        initVitals[vitalSign] = values.initial
    })
    // console.log(initVitals)
    return initVitals
}

const getBadVitals = (scenario) => {
    // console("in getBadVitals")
    const badVitals = {}
    Object.entries(scenario.vitalSigns).forEach(([vitalSign, values]) => {
        // console.log(vitalSign, values)
        badVitals[vitalSign] = values.bad
    })
    // console.log(initVitals)
    return badVitals
}

const getGoodVitals = (scenario) => {
    // console("in getGoodVitals")
    const goodVitals = {}
    Object.entries(scenario.vitalSigns).forEach(([vitalSign, values]) => {
        // console.log(vitalSign, values)
        goodVitals[vitalSign] = values.good
    })
    // console.log(initVitals)
    return goodVitals
}

// Actions begin
const timeExpired = (payload) => {
    // alert(payload);
    console.log("time expired")
}

const bar = () => {
    console.log("bar");
}

const ACTIONS = {
    "timeExpired": timeExpired,
    "bar": bar
}
// Actions end

export const ScenarioProvider = ({scenario, defaultValues, children}) =>{
    const {db} = useFirebase()
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { currentUser, getUserData } = useContext(AuthContext)
    // , getUserData, isAuthenticated, saveUserData;
    const [currentAssessmentFinding, setCurrentAssessmentFinding] = useState(null)
    const [checkListItems, setCheckListItems] = useState(defaultValues.checkListItems)
    const [currentVitals, setCurrentVitals] = useState( getInitialVitals(scenario) )
    const [vitalsRecomputed, setVitalsRecomputed] = useState(defaultValues.vitalsRecomputed)
    const [currPhase, setCurrPhase] = useState(null)
    const [currSubPhase, setCurrSubPhase] = useState(null)
    const [currIntvCat, setCurrIntvCat] = useState("")
    const [currIntv, setCurrIntv] = useState(null)
    const [intvsPerformedCollapsed, setIntvsPerformedCollapsed] = useState(true)
    const [showScenarioComplete, setShowScenarioComplete] = useState(false)
    const [showFindings, setShowFindings] = useState(false)
    const [showIntvSelection, setShowIntvSelection] = useState(false)
    const [patientStatusRequests, setPatientStatusRequests] = useState([])
    const [patientStatusTab, setPatientStatusTab] = useState("vitals")
    const [systemsTab, setSystemsTab] = useState("airway")
    const [intvHistory, setIntvHistory] = useState(defaultValues.intvHistory)
    //const [findingsUpdates, setFindingsUpdates] = useState(defaultValues.findingsUpdates)
    const [generalFindings, setGeneralFindings] = useState([])
    const [airwayFindings, setAirwayFindings] = useState([])
    const [breathingFindings, setBreathingFindings] = useState([])
    const [circulationFindings, setCirculationFindings] = useState([])
    const [started, setStarted] = useState(false)
    const [paused, setPaused] = useState(false)
    const [timestamp, setTimestamp] = useState(0)
    const [timers, setTimers] = useState([scenarioTimer(scenario)])
    const [timerError, setTimerError] = useState(null)
    const [actionsQueue, setActionsQueue] = useState([])
    const [collapsed, setCollapsed] = useState({});
    const [updateRules, setUpdateRules] = useState(undefined)


    // expose accesor rather than timestamp, in effect making it a private variable
    const getTimestamp = () => timestamp

    const clearTimerError = () => setTimerError(null)

    useEffect(() => {
      const interval = setInterval(() => tick(), 1000)
      // cleanup interval
      return () => {
        clearInterval(interval)
      }
    })

    useEffect(() => {
        if (Object.keys(actionsQueue).length !== 0) {
            let currActionString = actionsQueue[0].type;
            let currActionPayload = actionsQueue[0].payload;
            let currAction = ACTIONS[currActionString];

            currAction(currActionPayload);
        }
    }, [actionsQueue])

    // Save scenario state
    // useEffect(
    //     () => {
    //         // as both class components .setState() and functional components useState() setters
    //         // both actually queue the setting of state, as an performance optimization for when
    //         // there are individual requests for state changes made in a relatively short period
    //         // of time,  making use of a useEffect() with a dependency array of all state variables
    //         // we're interested in persisting to the db is a perfect place to capture when they
    //         // have actually been changed, and thus persist those changes.  since we're not hooked
    //         // up to the db yet, I'm merely console.log()ing that things have changed, and listing
    //         // what state we'll be persisting to the db.
    //         saveUserData(scenario.id, {
    //             currentAssessmentFinding,
    //             checkListItems,
    //             currentVitals,
    //             vitalsRecomputed
    //         });
    //     },
    //     [
    //         currentAssessmentFinding,
    //         checkListItems,
    //         currentVitals,
    //         vitalsRecomputed
    //     ]
    // )

    // Load and apply scenario state
    // useEffect(() => {
    //     // isAuthenticated &&
    //     getUserData()
    //         .then(res => {
    //             let state = res[scenario.id];

    //             // Set all states
    //             setCurrentAssessmentFinding(state.currentAssessmentFinding);
    //             setCheckListItems(state.checkListItems);
    //             setCurrentVitals(state.currentVitals);
    //             setVitalsRecomputed(state.vitalsRecomputed);
    //         })
    //         .catch(err => console.log(err));
    // }, []);

    useEffect( () => {
            // FIXME: this is for devel purposes only
            console.log(checkListItems)
        }, [checkListItems]
    )
    useEffect(() => {
            // FIXME: this is for devel purposes only
            console.log(patientStatusRequests)
        }, [patientStatusRequests]
    )

    const tick = () => {
        if (started && !paused) {
            setTimestamp(timestamp + 1);  // Increase the timestamp by 1 if the timers have been started and are not paused
            const newTimers = timers.map((timer) => {
                const newTimer = Object.assign(timer)
                if (!timer.expired) {
                    if (timer.timeRemaining === 1) {
                        newTimer.expired = true
                        if (newTimer.action != null) {  // != instead of !== is intentional
                            const newActionsQueue = actionsQueue.slice();
                            newActionsQueue.push(newTimer.action);
                            setActionsQueue(newActionsQueue);
                        }
                    }
                    newTimer.timeRemaining--
                }
                return newTimer
            })
            setTimers(newTimers)
        }
    }

    const registerTimer = (id, duration, action = null, timeRemaining = null, expired = false) => {
        timeRemaining = timeRemaining ?? duration
        const found = timers.find((timer) => timer.id === id)
        if (found) {
            setTimerError(`ERROR: timer: "${id}" already registered`)
        } else {
            const newTimers = timers.slice()
            newTimers.push({ id, duration, action, timeRemaining, expired })
            setTimers(newTimers)
        }
    }

    const cancelTimer = (id) => {
        const found = timers.find((timer) => timer.id === id);
        if (found) {
            let newTimers = timers.filter(timer => timer.id !== id);  // Returns an array with everything except the removed timer
            setTimers(newTimers);
        } else {
            setTimerError(`ERROR: timer: "${id}" not found`)
        }
    }


    const setCollapsedValue = (id, boolVal) => {
        setCollapsed(prevState => ({
            ...prevState, [id]: boolVal
        }))
    }

    const toggleCollapsed = (id) => {
        setCollapsedValue(id, !getCollapsed(id));
    }

    const getCollapsed = (id) => {
        return collapsed[id];
    }

    const isChecked = (id) => {
        return !!checkListItems[id]
    }

    const setChecked = (id, boolVal) => {
        const newValue = boolVal ? getTimestamp() : false
        setCheckListItems(prevState => ({
            ...prevState, [id]: newValue
        }))
    }

    const toggleChecklistItem = (ans) => {
        const currVal = isChecked(ans.id)
        if (!currVal) {
            const data = Object.assign(
                {},
                ans, {
                timestamp: getTimestamp(),
                phase: currPhase,
                subPhase: currSubPhase
            })
            console.log("logging checkListItem", ans.id, data)
            setCheckListItems(prevState => ({
                ...prevState, [ans.id]: data
            }))
        } else {
            console.log("logging checkListItem:", ans.id, false)
            setChecked(ans.id, false)
        }
    }
    const toggleAssessmentItem = (ans) => {
        const currVal = isChecked(ans.id)
        if (!currVal) {
            const data = Object.assign(
                {},
                ans, {
                timestamp: getTimestamp(),
                phase: currPhase,
                subPhase: currSubPhase,
                finding: scenario.assessmentFindings[ans.id]
            })
            console.log("logging assessmentItem", ans.id, data)
            setCheckListItems(prevState => ({
                ...prevState, [ans.id]: data
            }))
        } else {
            console.log("logging assessmentItem:", ans.id, false)
            setChecked(ans.id, false)
        }
    }
    const toggleIntvAnswer = (ans) => {
        const currVal = isChecked(ans.id)
        if (!currVal) {
            const data = Object.assign(
                {},
                ans, {
                    timestamp: getTimestamp(),
                    intervention: currIntv,
                    interventionCategory: currIntvCat,
                    phase: currPhase,
                    subPhase: currSubPhase
                 })
            console.log("logging intvAnswer:", ans.id, data)
            setCheckListItems(prevState => ({
                ...prevState, [ans.id]: data
            }))
        } else {
            console.log("logging intvAnswer", ans.id, false)
            setChecked(ans.id, false)
        }
    }

    // const setIntv = (id, label, system, boolVal) => {
    //     const logData = {
    //         id: id,
    //         type: "intervention",
    //         label: label,
    //         system: system,
    //         timestamp: getTimestamp(),
    //         phase: currPhase,
    //         subPhase: currSubPhase,
    //         interventionCategory: currIntvCat
    //     }
    //     if (boolVal) {
    //         console.log("logging intv", id, logData)
    //         setCheckListItems(prevState => ({
    //             ...prevState, [id]: logData
    //         }))
    //     } else {
    //         console.log("logging intv", id, false)
    //         setChecked(id, false)
    //     }
    // }

    // const toggleChecked = (id) => {
    //     setChecked(id, !isChecked(id))
    // }

    const someChecked = (ids) => {
        const result = ids.some(id => isChecked(id))
        // console.log(`someChecked(${ids}): ${result}`)
        return result
    }

    const allChecked = (ids) => {
        const result = ids.every(id => isChecked(id))
        // console.log(`allChecked(${ids}): ${result}`)
        return result
    }

    const isCurrentAssessmentFinding = (id) => {
        return !!currentAssessmentFinding && currentAssessmentFinding === id
    }

    // const toggleAssessmentFinding = (id) => {
    //     const stepIsChecked = isChecked(id)
    //     setCurrentAssessmentFinding(!stepIsChecked ? id : null)
    //     // setCurrentInterventionForm(null)
    //     toggleChecked(id)
    // }

    const setVital = (vital, value) => {
        setCurrentVitals(prevState => ({
            ...prevState, [vital]: value
        }))
    }

    const setVitals = (vitals) => {
        setCurrentVitals(vitals)
    }

    const saveScenarioToLog = async (label = "") => {
        const userData = await getUserData();
        const docRef = await db.collection("logs").doc()
        let data = {
            userName: currentUser.email,
            scenarioID: scenario.id,
            scenarioName: scenario.name,
            schemaVersion: scenario.schemaVersion,
            label: label,
            classCode: userData.classCode || "",
            condition: userData.condition || "",
            timestamp: Date().toLocaleString()
        }
        // let values = Object.values(checkListItems).filter(rec => !!rec && rec.constructor.name === "Object")
        let clis = Object.values(checkListItems).filter(rec => !!rec && rec.constructor.name === "Object")

        //added by Pam to replace unknown with null due to some hiccup in the editor (i.e. should be able to do
        //away with this once original bug is fixed)
        clis.forEach(function (logObj,index){
            for (let [key, val] of Object.entries(logObj)) {
                if (undefined === val) {
                    (clis[index])[key] = null
                 }
            }}
        )

        const values = clis.concat(patientStatusRequests).concat(intvHistory)
        // values = values.concat(patientStatusRequests)
        values.sort((recA, recB) => recA.timestamp - recB.timestamp)
        data["events"] = values
        data["checkListItems"] = clis
        data["patientStatusRequests"] = patientStatusRequests
        data['interventionHistory'] = intvHistory
        // // console.log(JSON.stringify(data, null, 4))
        // console.log(data)
        await docRef.set(data)
        return docRef.id
    }

    const buildDepListFromCheckListItemIDs = (ids) => ids.map(id => isChecked(id))

    const getCheckListIDValues = (ids) => ids.map(id => isChecked(id))

    const setDerivedCheckListItemValue = (id, depChecker, deps) => {
        const currVal = isChecked(id)
        const newVal = ("all" === depChecker) ? allChecked(deps) : someChecked(deps)
        // don't update checkListItems if we don't have an actual change
        if (currVal !== newVal) {
            console.log(`setDerivedCheckListItemValue(${id}, "${depChecker}", [${deps}]): ${newVal}`)
            setChecked(id, newVal)
        }
    }

    const evalIDExpression = (exp) => {
        // console.log("before", exp)
        exp = exp.replace(/AND/g, ' && ')
            .replace(/OR/g, ' || ')
            .replace(/NOT\s*/g, ' !');
        const re = /[a-z][-a-z0-9]*/g;
        const matches = exp.matchAll(re);
        for (let match of matches) {
            exp = isChecked(match)
                ? exp.replace(match, 'true')
                : exp.replace(match, 'false');
        }
        // console.log("after", exp)
        const val = logicalExprParser.expressionToValue(exp)
        // console.log("value", val)
        return val
    }

    const extractIDsFromExpression = (exp) => {
        exp = exp.replace(/AND/g, " ")
                 .replace(/OR/g, " ")
                 .replace(/NOT\s*/g, " ")
                 .replace(/\(/g, " ")
                 .replace(/\)/g, " ")
        const re = /[a-z][-a-z0-9]*/g
        const matches = exp.matchAll(re)
        return Array.from(matches, x => x[0])
    }

    const displayFindings = (event) => {
        event.preventDefault()
        setShowFindings(true)
    }

    const dismissFindings = (event) => {
        event.preventDefault()
        setShowFindings(false)
    }

    const toggleIntvsPerformedCollapsed = () => {
        setIntvsPerformedCollapsed(!intvsPerformedCollapsed)
    }

    const logPatientStatusRequest = (category, type, value) => {
        const rec = {
            id: `request-${category}-${type}`,
            type: "obtain-vital-sign",
            vitalType: category,
            vital: type,
            value: value,
            timestamp: getTimestamp(),
            phase: currPhase,
            subPhase: currSubPhase
        }
        setPatientStatusRequests(prevState => [...prevState, rec])
    }

    const logIntv = (intvData) => {
        setIntvHistory(prevState => [...prevState].concat(intvData))
        checkForVitalsChange(intvData.interventionID)
        updateAssessmentStatus(intvData)
    }

    const initializeUpdateRules = () => {
        let rules
        if (!updateRules) {
            rules = intvStatusRules[scenario.name]
            for (let rule of rules) {
                rule.fired = false
            }
            setUpdateRules(rules)
        }
        return rules
}

    const updateFindings = (findings, update) => {
        let entry = findings.findLast(e => e.label === update.label)
        if (!entry || (!!entry && entry.value !== update.value)){
            findings.push(update)
        }
        return findings

    }

    const updateAssessmentStatus = (intvData) => {
        let rules
        if (!updateRules){
            rules = initializeUpdateRules()
        }
            else {rules = updateRules}
            
        for (let rule of rules) {
            if (!rule.fired) {
                let history = (intvHistory.concat(intvData)).map(e => e.interventionID)
                let nots = rule["nots"] || []
                let notResult = nots.filter(e => history.includes(e))
                let ands = rule["ands"] || []
                let andResult = ands.filter(e => history.includes(e))
                
                //let andResult = intvHistory.concat(intvData).filter(e => ands.includes(e.interventionID))
                let updates = rule["updates"]
                if (notResult.length === 0 && 
                    updates &&
                    (ands.length === 0 || (!!andResult && ands.length === andResult.length))) {
                    rule.fired = true
                    for (let update of updates) {

                        //Only update an assessment finding in the checklist if it is in
                        //the secondary assessment section
                        let assessment = scenario._checkListMetaData.find(rec => rec.id === update.id)
                        if (assessment && assessment.phase === "secondary-assessment"){
                            scenario.assessmentFindings[update.id] = update.val}

                        //if a tab value is provided, put the update label and val in that tab
                        //if val has changed since the last time
                        if (update.tab && (update.tab).length !== 0) {
                            let result
                            let updateVal = {label: update.label, value: update.val}
                            update.tab.forEach(tab => {
                                switch (tab) {
                                    case "General":
                                        result = updateFindings(generalFindings, updateVal)
                                        setGeneralFindings(result)
                                        break;
                                    case "A":
                                        result = updateFindings(airwayFindings, updateVal)
                                        setAirwayFindings(result)
                                        break;
                                    case "B":
                                        result = updateFindings(breathingFindings, updateVal)
                                        setBreathingFindings(result)
                                        break;
                                    case "C":
                                        result = updateFindings(circulationFindings, updateVal)
                                        setCirculationFindings(result)
                                        break;
                                    default:
                                        break;
                                }
                            })
                        }
                    }
                }
            }
            setUpdateRules(rules)
        }
    }
    

    const checkForVitalsChange = (newIntvID) => {
        let good = false
        let intvIDs = (intvHistory.map(int => int.interventionID)).concat([newIntvID])
        //may have more than one set of alternative interventions to check
        let intvSets = intvsCritical[scenario.name]
        for (let intvs of intvSets){
            let difference = intvs.filter(x => !intvIDs.includes(x))
            if (difference.length === 0){
                setVitals(getGoodVitals(scenario))
                good = true
                break}
        }  
       if (!good){
            let clis = Object.values(checkListItems).filter(rec => !!rec && rec.constructor.name === "Object")
            let actions = clis.concat(patientStatusRequests)
            let vitalsCount = doVitalsCounts(actions,scenario.name,vitalsToStep)
            for (const [ , count] of Object.entries(vitalsCount)){
                if (count >= 2){  //if any vital has been checked 2 times or more, assuming now into reassessment
                    setVitals(getBadVitals(scenario))
                    break}
                }
        }
    }
        

    const getIntvHistory = (intvID) => {
        return intvHistory.filter(rec => rec.interventionID === intvID)
    }

    const getIntvVariantHistory = (intvID, intvVariant) => {
        return getIntvHistory(intvID).filter(rec => rec.intvVariant === intvVariant)
    }

    // const updateIntvHistory = (intvID, newValue) => {
    //     const mostRecentIdx = intvHistory.findLastIndex(e => e.id === intvID)
    //     const copy = [...intvHistory]
    //     copy[mostRecentIdx] = newValue
    //     setIntvHistory(copy)
    // }

    return (
        <ScenarioContext.Provider
            value={{
                scenario,
                checkListItems,
                isChecked,
                setChecked,
                // toggleChecked,
                someChecked,
                allChecked,
                toggleChecklistItem,
                toggleAssessmentItem,
                toggleIntvAnswer,
                // setIntv,
                isCurrentAssessmentFinding,
                setCurrentAssessmentFinding,
                // toggleAssessmentFinding,
                currIntv,
                setCurrIntv,
                currentVitals,
                setVital,
                vitalsRecomputed,
                setVitalsRecomputed,
                started,
                setStarted,
                paused,
                setPaused,
                getTimestamp,
                timers,
                timerError,
                actionsQueue,
                registerTimer,
                cancelTimer,
                clearTimerError,
                setTimerError,
                setCollapsedValue,
                toggleCollapsed,
                getCollapsed,
                showScenarioComplete,
                setShowScenarioComplete,
                saveScenarioToLog,
                buildDepListFromCheckListItemIDs,
                getCheckListIDValues,
                setDerivedCheckListItemValue,
                evalIDExpression,
                extractIDsFromExpression,
                showFindings,
                displayFindings,
                dismissFindings,
                currIntvCat,
                setCurrIntvCat,
                currPhase,
                setCurrPhase,
                currSubPhase,
                setCurrSubPhase,
                intvsPerformedCollapsed,
                toggleIntvsPerformedCollapsed,
                showIntvSelection,
                setShowIntvSelection,
                patientStatusRequests,
                logPatientStatusRequest,
                patientStatusTab,
                setPatientStatusTab,
                generalFindings,
                setGeneralFindings,
                airwayFindings,
                setAirwayFindings,
                circulationFindings,
                setCirculationFindings,
                breathingFindings,
                setBreathingFindings,
                systemsTab,
                setSystemsTab,
                logIntv,
                intvHistory,
                getIntvHistory,
                getIntvVariantHistory,
                setUpdateRules,
                updateRules

            }}
        >
            {children}
        </ScenarioContext.Provider>
    )
}

export const useScenario = () => useContext(ScenarioContext)